export const NOME = "nome";
export const COGNOME = "cognome";
export const CF = "codiceFiscale";
export const EMAIL = "email";
export const TELEFONO = "telefono";
// Possibili campi ritorno userInfo
export const NOME_API = "name";
export const COGNOME_API = "familyName";
export const CF_API = "fiscalNumber";
export const EMAIL_API = "email";
export const TELEFONO_API = "mobilePhone";
// Campi di ritorno userInfo prima della modifica dei claims WSO2
export const NOME_OLD_API = "Nome";
export const COGNOME_OLD_API = "Cognome";
export const CF_OLD_API = "CodiceFiscale";
export const EMAIL_OLD_API = "E-mail";
export const TELEFONO_OLD_API = "NumeroCellulare";
